import { useState } from 'react';

import { debounce } from '@mui/material';

import { isElementAboveViewport } from '../helpers';
import { useEventListener } from '../hooks';

const useHidingStickyBlock = (elementRef) => {
  const [visible, setVisible] = useState(false);

  useEventListener(
    'scroll',
    debounce(() => {
      setVisible(isElementAboveViewport(elementRef.current, -100));
    }, 100),
  );

  return visible;
};

export default useHidingStickyBlock;
